import { saveAs } from '@upright/ui/common/generic/utilities/save-as';
import { utils, write } from 'xlsx';

// Data for a full spreadsheet with multiple sheets
type SpreadsheetData = { [sheetName: string]: SheetData };
// Data for a single sheet, to be converted into tabular format
type SheetData = Array<{ [columnName: string]: number | string | null | undefined }>;

export function downloadAsXlsx(dataBySheetName: SpreadsheetData, filenameWithoutExtension: string) {
  const { xlsxBlob, extension } = spreadsheetToXlsxFile(dataBySheetName);
  saveAs(xlsxBlob, `${filenameWithoutExtension}.${extension}`);
}

export function spreadsheetToXlsxFile(dataBySheetName: SpreadsheetData) {
  const arrayBuffer = spreadsheetToXlsxDataArray(dataBySheetName);
  return {
    xlsxBlob: new Blob([arrayBuffer], {
      type: 'application/octet-stream',
    }),
    extension: 'xlsx',
  };
}

function spreadsheetToXlsxDataArray(dataBySheetName: SpreadsheetData) {
  const workbook = utils.book_new();
  Object.keys(dataBySheetName).forEach(sheetName => {
    workbook.SheetNames.push(sheetName);
    // Note: if we don't pass in a { columns: ... } option to json_to_sheet, the
    // ordering of the columns defaults to Object.keys(worksheetData[n]). This
    // currently works but the ordering is theoretically undefined.
    workbook.Sheets[sheetName] = utils.json_to_sheet(dataBySheetName[sheetName]);
  });
  return s2ab(write(workbook, { bookType: 'xlsx', bookSST: false, type: 'binary' }) as string);
}

// From https://github.com/SheetJS/js-xlsx#writing-workbooks
function s2ab(s: string) {
  const buf = new ArrayBuffer(s.length);
  const view = new Uint8Array(buf);
  // NOTE: must be `s.length`, not `length`. The latter resolves to the global
  // `window.length` (number of frames in the window, typically 0 in our SPA),
  // which silently produced all-zero xlsx files. See PR #6906 + PR #7030.
  for (let i = 0; i !== s.length; ++i) {
    view[i] = s.charCodeAt(i) & 0xff;
  }
  return buf;
}
